var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',{staticClass:"max-width"},[(!_vm.loading)?_c('router-view'):_c('Loader')],1)}
var staticRenderFns = []

export { render, staticRenderFns }